import { domains } from 'config/env'
export const CLICK = 'click'
export const ENTER = 'Enter'
export const CLOSE = 'CLOSE'
export const USER_MANAGEMENT_PATH = `${domains.ADMIN_DOMAIN}/user-management`
